import { config } from '../_config';
import {updateService as updateS} from './update.service';
import {fakeUpdateService as updateFS} from './fake.update.service';
import { fakeLinkService as linksFS } from "./fake.links.serivce";
import { linkService as linksS } from "./links.service";
import { IUpdateService, ILinksService, ISettingDownloadService, IUpdateComponent } from '../_types/interfaces';
import { settingService as settingS } from './setting.download.service';
import { fakeSettingService as settingFS} from './fake.setting.download.service';
import { updateService as componentS } from './components.service';
import { fakeUpdateService as componentFS} from './fake.components.service';

export let updateService: IUpdateService;
export let updateComponent: IUpdateComponent;
export let linkService: ILinksService;
export let settingService: ISettingDownloadService;

if (config.useFake === true) {
    updateService = updateFS;
    linkService = linksFS;
    settingService = settingFS
    updateComponent = componentFS
} else {
    updateService = updateS;
    linkService = linksS;
    settingService = settingS
    updateComponent = componentS
}